import { createMMKV } from 'react-native-mmkv';

// ─────────────────────────────────────────────────────────────────────────────

export const permissionsStorage = createMMKV({ id: 'sg.permissions' });
